import React from 'react';
import PropTypes from 'prop-types';

import './NavToggle.scss';

const NavToggle = props => {
  const { navCollapsed, toggleCollapse } = props;

  return (
    <a
      href="#nogo"
      className={`${navCollapsed ? 'nav-toggle' : 'nav-toggle--collapsed'}`}
      onClick={toggleCollapse}
    >
      {navCollapsed && <i className="icon-right-open" />}
      {!navCollapsed && <i className="icon-left-open" />}
    </a>
  );
};

NavToggle.propTypes = {
  toggleCollapse: PropTypes.func,
  navCollapsed: PropTypes.bool
};

export default NavToggle;
